function Footer(){
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="bg-light">
          <div className="card-body text-center">&#169;Copyright 2010 - 2021</div>
        </div>
      </div>      
    </div>   
  );
}

export default Footer;